/*
 * Custom World Cup Contest — countdown to a target date (shows 00:00:00 once
 * reached), "How does it work?" modal, and the "Check Winnerboard" scroll.
 * T&C accordions use native <details>, so no JS needed for those.
 */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* ---- Countdown ---- */
  document.querySelectorAll('[data-wcc-timer]').forEach(function (root) {
    var endStr = root.getAttribute('data-end');
    var target = endStr ? new Date(endStr).getTime() : NaN;
    var hEl = root.querySelector('[data-h]');
    var mEl = root.querySelector('[data-m]');
    var sEl = root.querySelector('[data-s]');
    if (!hEl || !mEl || !sEl) { return; }

    function tick() {
      var remaining = 0;
      if (!isNaN(target)) { remaining = Math.max(0, Math.floor((target - Date.now()) / 1000)); }
      var h = Math.floor(remaining / 3600);
      var m = Math.floor((remaining % 3600) / 60);
      var s = remaining % 60;
      hEl.textContent = pad(h);
      mEl.textContent = pad(m);
      sEl.textContent = pad(s);
    }
    tick();
    if (!isNaN(target) && target > Date.now()) { setInterval(tick, 1000); }
  });

  /* ---- How-it-works modal ---- */
  document.querySelectorAll('[data-wcc-modal]').forEach(function (modal) {
    var root = modal.closest('.wcc') || document;
    function open() { modal.removeAttribute('hidden'); document.body.style.overflow = 'hidden'; }
    function close() { modal.setAttribute('hidden', ''); document.body.style.overflow = ''; }

    root.querySelectorAll('[data-wcc-open-modal]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    modal.querySelectorAll('[data-wcc-close-modal]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    // "Check Winnerboard" → close modal + scroll to the leaderboard
    modal.querySelectorAll('[data-wcc-check]').forEach(function (b) {
      b.addEventListener('click', function () {
        close();
        var board = root.querySelector('[data-wcc-board]');
        if (board) { board.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
    });
  });

  /* ---- Back button ---- */
  document.querySelectorAll('[data-wcc-back]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (window.history.length > 1) { window.history.back(); } else { window.location.href = '/'; }
    });
  });
})();
